// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"7b2ddb91","453":"02004393","550":"689a0b8c","608":"f3858ae2","707":"246fe558"}[chunkId] + ".chunk.js";
};